import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource, MatSort,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';
import { TripService } from '../../services/trip/trip.service';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component'
import { PdfgeneratorService } from '../../services/pdfgenerator/pdfgenerator.service';
import { ExcelgeneratorService } from '../../services/excelgenerator/excelgenerator.service';
import html2canvas from 'html2canvas';
import { NgxDateRangePickerOptions } from 'src/ngx-daterangepicker';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { TokenStorage } from 'src/app/auth/token.storage';

@Component({
  selector: 'app-tripanalytics',
  templateUrl: './tripanalytics.component.html',
  styleUrls: ['./tripanalytics.component.scss']
})
export class TripanalyticsComponent implements OnInit {
  columnsToDisplay = [
    'tripName',
    'tripCreatedDate',
    'orderQTY',
    'tripstate',
    'deliveryBoy',
    'vehicleNo',
    'tripStartDate',
    'tripEndDate',
    'tripTime',
    'tripDistance',
    'lastLocation',
    'warehouse',
    'tripGpsDistance',
    'tripCost'
  ];
  tripDataArray = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  options: NgxDateRangePickerOptions;
  page: number = 0;
  totalRecords: Number;
  excelRecords = [];
  selected = '7';
  daterRangevalue: any;
  fromDate: any;
  toDate: any;
  isDateFiltered: boolean = false;
  trips = [];
  isKohinoor: boolean = false;
  isLoading: boolean = false;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();



  constructor(
    public dialog: MatDialog,
    public tripService: TripService,
    public generatePdf: PdfgeneratorService,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe,
    public decimalPipe: DecimalPipe,
    private token: TokenStorage
  ) {
    if (token.getTenant() == 'kohinoor-reta-prod')
      this.isKohinoor = true;
  }

  ngOnInit() {
    this.createInitialFilter();
  }

  dataForExcel() {
    let tripalyticsAnData = [];
    if (this.tripDataArray.filteredData)
      tripalyticsAnData = this.tripDataArray.filteredData;
    else
      tripalyticsAnData = this.tripDataArray.data;
    this.excelRecords = [];
    tripalyticsAnData.forEach(trip => {


      let tripCreatedDate, tripStartedDate, tripEndedDate, triptime, tripdistance, warehouse, lastDeliveryLocation,
        odometerStart, odometerEnd, driverMobile, vehicleType, helper, tripGpsDistance, tripCost;

      if (trip.trip_created_time)
        tripCreatedDate = this.datePipe.transform(trip.trip_created_time, "medium");
      else
        tripCreatedDate = '-----'

      if (trip.trip_start_time)
        tripStartedDate = this.datePipe.transform(trip.trip_start_time, "medium");
      else
        tripStartedDate = '-----'

      if (trip.trip_end_time)
        tripEndedDate = this.datePipe.transform(trip.trip_end_time, "medium");
      else
        tripEndedDate = '-----'

      if (trip.trip_time)
        triptime = trip.trip_time + "hrs"
      else
        triptime = '-----'

      if (trip.trip_distance)
        tripdistance = trip.trip_distance + "kms"
      else
        tripdistance = '-----'

      if (trip.last_Delivery_Address)
        lastDeliveryLocation = trip.last_Delivery_Address;
      else
        lastDeliveryLocation = '-----';

      if (trip.odometer_start)
        odometerStart = trip.odometer_start;
      else
        odometerStart = '-----';

      if (trip.odometer_end)
        odometerEnd = trip.odometer_end;
      else
        odometerEnd = '-----';

      if (trip.driver_mobile)
        driverMobile = ', ' + trip.driver_mobile;
      else
        driverMobile = '';

      if (trip.vehicle_type)
        vehicleType = ', ' + trip.vehicle_type;
      else
        vehicleType = '';

      if (trip.driver_helper)
        helper = '/Helper: ' + trip.driver_helper;
      else
        helper = '';

      if (trip.trip_gps_distance)
        tripGpsDistance = trip.trip_gps_distance;
      else
        tripGpsDistance = '';
      if (trip.trip_cost)
        tripCost = trip.trip_cost
      else
        tripCost = 0



      if (trip) {
        if (this.isKohinoor) {
          this.excelRecords.push({
            'Trip Name': trip.trip_name,
            'Trip Created Date': tripCreatedDate,
            'Total Orders': trip.total_number_of_orders,
            'Trip State': trip.status.slice(11),
            'Delivery Boy': trip.delivered_by ,
            'Helper': helper,
            'Mobile No.': driverMobile,
            'Vehicle No.': trip.vehicle_number,
            'Vehicle Type': vehicleType,
            'Trip Started Date': tripStartedDate,
            'Trip Ended Date': tripEndedDate,
            'Odometer Reading': 'Start:' + odometerStart + ', End:' + odometerEnd,
            'Trip Time': triptime,
            'Trip Distance': tripdistance,
            'Last Delivery Location': lastDeliveryLocation,
            'Warehouse': trip.trip_warehouse,
            'Gps Distance': tripGpsDistance,
            'Trip Cost': tripCost,
            'Transporter': trip.transporter_name,
            'Transporter Contact Person': trip.transporter_contact_person_name,
            'Transporter Contact Mobile': trip.transporter_contact_person_mobile
          });
        }
        else {
          this.excelRecords.push({
            'Trip Name': trip.trip_name,
            'Trip Created Date': tripCreatedDate,
            'Total Orders': trip.total_number_of_orders,
            'Trip State': trip.status.slice(11),
            'Delivery Boy/Mobile No.': trip.delivered_by + helper + driverMobile,
            'Vehicle No./Vehicle Type': trip.vehicle_number + vehicleType,
            'Trip Started Date': tripStartedDate,
            'Trip Ended Date': tripEndedDate,
            'Odometer Reading': 'Start:' + odometerStart + ', End:' + odometerEnd,
            'Trip Time': triptime,
            'Trip Distance': tripdistance,
            'Last Delivery Location': lastDeliveryLocation,
            'Warehouse': trip.trip_warehouse,
            'Gps Distance': tripGpsDistance,
            'Trip Cost': tripCost
          });
        }
      }
    });
  }

  public captureScreen() {
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      this.generatePdf.pdfgenerator(canvas, this.tripDataArray.data.length);
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'tripreport');
  }

  ngAfterViewInit() {
    this.tripDataArray.paginator = this.paginator;
  }
  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.isDateFiltered = true;
    this.tripFilter();
  }

  tripFilter() {
    this.isLoading = true;
    this.tripDataArray.data = [];
    this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(trips => {
      console.log("Trips in report", trips);
      this.tripDataArray.data = trips;
      this.tripDataArray.sortingDataAccessor = (item: any, property) => {
        switch (property) {
          case 'tripstate': return item.status;
          case 'deliveryBoy': return item.delivered_by;
          case 'tripStartDate': return item.trip_start_time;
          case 'warehouse': return item.trip_warehouse;
        }
      };
      this.tripDataArray.sort = this.sort;
      this.isLoading = false;
    },Error=>{
      this.isLoading = false;
    })
  }

  getData(from, to) {
    return this.tripService.getTripReport(from, to);
  }

  sortByDate() {
    if (this.daterRangevalue != undefined) {
      this.ngUnsubscribe.next();
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      this.isDateFiltered = true;
      this.tripFilter();
    }
  }

  clearAllFilter() {
    this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.isDateFiltered = false;
  }

  tripDetails(tripId) {
    let tripdialog = this.dialog.open(TripdetailsComponent, {
      width: '800px',
      data: {
        component: 'tripreport',
        tripid: tripId,
      }
    });
    tripdialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  applyFilter(filterValue: string) {
    this.tripDataArray.filter = filterValue.trim().toLowerCase();
  }
}